export const VALID_SPECIALIZATIONS_FOR_TRAINEE = [
  'JavaScript',
  'Java',
  'Scala',
  'PHP',
  '.NET',
  'Python',
  'Ruby',
  'Golang',
  'iOS',
  'Android',
  'C++',
  'DevOps',
  'Data Engineering',
  'Data Analytics',
  'Business Intelligence',
  'Data Science',
  'QA Manual',
  'QA Automation',
  'Business Analysis',
  'System Analysis',
  'UI/UX Design',
  'Graphic Design',
];

export const DEV_SPECIALIZATIONS = [
  'JavaScript',
  'Java',
  'Scala',
  'PHP',
  '.NET',
  'Python',
  'Ruby',
  'Golang',
  'iOS',
  'Android',
  'C++',
  'DevOps',
  'Data Engineering',
  'Data Analytics',
  'Business Intelligence',
  'Data Science',
];

export const NOT_DEV_SPECIALIZATIONS = [
  'QA Manual',
  'QA Automation',
  'Business Analysis',
  'System Analysis',
  'UI/UX Design',
  'Graphic Design',
];
